import { render, staticRenderFns } from "./purchaseRetrunRedAccount.vue?vue&type=template&id=4dbbcf29&scoped=true"
import script from "./purchaseRetrunRedAccount.vue?vue&type=script&lang=js"
export * from "./purchaseRetrunRedAccount.vue?vue&type=script&lang=js"
import style0 from "./purchaseRetrunRedAccount.vue?vue&type=style&index=0&id=4dbbcf29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbcf29",
  null
  
)

export default component.exports